import classes from "./SpecOffer.module.css";
import MediaS from "../MediaS";
import AddMedia from "../AddMedia";
import logo from "../../../store/logo.png"
import {useCallback, useEffect, useRef, useState} from "react";
import ModalView from "../Modal/ModalView";
import axios from 'axios';
import {path} from "../../../routes"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Typography,
    CircularProgress,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Switch,
    FormControlLabel,
    Checkbox
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import EditIcon from '@mui/icons-material/Edit';

const RADISSON_BLU_ORG_ID = 'AC9D7FD5-E333-4B1E-9043-4697568313B7';
const HOLIDAY_INN_ORG_ID = 'E15F8010-B7EB-4526-A985-F00D517EBF4C';
/** Skupina „Default screen (Totem)“ – zobrazuje obrázky z Set default (Top/Bottom při žádném meetingu). Pouze Holiday Inn. */
const DEFAULT_SCREEN_GROUP_ID = -1;

const SpecOffer = (props) =>{
    const [user, setUser] = useState(props.cred);
    const [loading, setLoading] = useState(true);
    const publicBaseUrl = String(path || '')
        .replace(/\/api\/?$/i, '')
        .replace(/\/$/, '');

    const toPublicUploadUrl = (p) => {
        if (!p) return '';
        if (String(p).startsWith('http')) return String(p);
        // Extract filename from path (remove all prefixes)
        const cleaned = String(p)
            .replace(/\\/g, '/')
            .replace(/^\/+/, '')
            .replace(/^admin\/uploads\//i, '')
            .replace(/^uploads\//i, '')
            .replace(/^admin\//i, '');
        // Always use /uploads/ prefix in the final URL
        return `${publicBaseUrl}/uploads/${cleaned}`;
    };

    // API fallback functions for group management
    const apiCandidates = (endpoint) => {
        const base = String(path || '').replace(/\/$/, '');
        const ep = String(endpoint || '').replace(/^\/+/, '');
        // Try both: s /api i bez (path může být https://x.cz/api nebo https://x.cz)
        const c1 = `${base}/${ep}`;
        const c2 = base.endsWith('/api') ? base.replace(/\/api$/, '') + '/' + ep : `${base}/api/${ep}`;
        return Array.from(new Set([c1, c2]));
    };

    const postWithFallback = async (endpoint, body) => {
        let lastErr;
        for (const url of apiCandidates(endpoint)) {
            try {
                return await axios.post(url, body);
            } catch (e) {
                lastErr = e;
                if (e?.response?.status && e.response.status !== 404) throw e;
            }
        }
        throw lastErr;
    };

    const putWithFallback = async (endpoint, body) => {
        let lastErr;
        for (const url of apiCandidates(endpoint)) {
            try {
                return await axios.put(url, body);
            } catch (e) {
                lastErr = e;
                if (e?.response?.status && e.response.status !== 404) throw e;
            }
        }
        throw lastErr;
    };

    const deleteWithFallback = async (endpoint, config = {}) => {
        let lastErr;
        for (const url of apiCandidates(endpoint)) {
            try {
                return await axios.delete(url, config);
            } catch (e) {
                lastErr = e;
                if (e?.response?.status && e.response.status !== 404) throw e;
            }
        }
        throw lastErr;
    };

    const temp = {
        id: 0,
        Header: "Namespace",
        Body: {
            file: "",
            imgURL: logo,
            elevators: [
                {
                    name: "E1_",
                    checked: false
                },
                {
                    name: "E2_",
                    checked: true
                },
                {
                    name: "E3_",
                    checked: false
                }
            ]
        }
    }
    const [idCount, setIdCount] = useState(1);
    const [currentID, setCurrentID] = useState(null);
    const [cards, setCards] = useState([])
    const [cardsNew, setCardsNew] = useState([])
    const [modalLoaded, setModalLoaded] = useState(false);
    const [modalVariant, setModalVariant] = useState(null);
    const [images, setImages] = useState([]);
    const [fileContent, setFileContent] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewCard, setPreviewCard] = useState(null);

    // --- Slide groups functionality ---
    const [groupid, setGroupid] = useState(0);
    const [slideGroups, setSlideGroups] = useState([]);
    const [devices, setDevices] = useState([]);
    const [createGroupModalOpen, setCreateGroupModalOpen] = useState(false);
    const [newGroupName, setNewGroupName] = useState('');
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [newGroupShowOnTotem, setNewGroupShowOnTotem] = useState(false); // zobrazit obrázky z této skupiny i na totemu
    const [editGroupModalOpen, setEditGroupModalOpen] = useState(false);
    const [editGroupName, setEditGroupName] = useState('');
    const [editGroupSelectedDevices, setEditGroupSelectedDevices] = useState([]);
    const [editGroupSlideInterval, setEditGroupSlideInterval] = useState('15'); // interval pro celou groupu (s)
    const [editGroupShowOnTotem, setEditGroupShowOnTotem] = useState(false); // zobrazit obrázky z této skupiny i na totemu

    // --- Kiosk demo (demoUrl / Demo modal; Kiosk settings removed) ---
    const [kioskDevices, setKioskDevices] = useState([]);
    const [selectedKioskId, setSelectedKioskId] = useState('');
    const [demoOpen, setDemoOpen] = useState(false);
    const [demoRatio, setDemoRatio] = useState('9:16'); // 9:16 | 16:9 | 4:3 (for demo URL)
    const [defaultScreenModalOpen, setDefaultScreenModalOpen] = useState(false);
    const [defaultScreenEditId, setDefaultScreenEditId] = useState(1);
    const [defaultScreenFile, setDefaultScreenFile] = useState(null);
    const [defaultScreenUploading, setDefaultScreenUploading] = useState(false);

    const RATIO_OPTIONS = ['9:16', '16:9', '4:3'];

    // Když se otevře Edit group, předvyplnit slide interval z prvního zařízení ve skupině (pokud má uložené nastavení)
    useEffect(() => {
        if (!editGroupModalOpen || !groupid) return;
        const groupIdNum = Number(groupid);
        const deviceInGroup = (devices || []).find(
            (d) => Number(d.roomGroup ?? d.room_group) === groupIdNum
        );
        if (!deviceInGroup) {
            setEditGroupSlideInterval('15');
            return;
        }
        const orgId = props.cred?.cOrganization_id;
        const url = orgId
            ? `${path}/getDeviceSettings/${deviceInGroup.id}?orgID=${encodeURIComponent(orgId)}`
            : `${path}/getDeviceSettings/${deviceInGroup.id}`;
        let cancelled = false;
        (async () => {
            try {
                const resp = await axios.get(url);
                if (cancelled) return;
                const sec = resp.data?.settings?.slideIntervalSec;
                if (typeof sec === 'number' && !Number.isNaN(sec)) {
                    const clamped = Math.max(3, Math.min(300, Math.floor(sec)));
                    setEditGroupSlideInterval(String(clamped));
                } else {
                    setEditGroupSlideInterval('15');
                }
            } catch {
                if (!cancelled) setEditGroupSlideInterval('15');
            }
        })();
        return () => { cancelled = true; };
    }, [editGroupModalOpen, groupid, devices, props.cred?.cOrganization_id]);

    const copyToClipboard = async (text) => {
        try {
            const value = String(text);
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(value);
                alert('Link copied to clipboard.');
                return true;
            }
            const ta = document.createElement('textarea');
            ta.value = value;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(ta);
            if (ok) alert('Link copied to clipboard.');
            return ok;
        } catch (e) {
            console.error('Copy failed:', e);
            return false;
        }
    };

    const getDisplayBaseUrl = () => {
        if (typeof window === 'undefined') return 'https://kiosk.csgcontrols.cz';
        return `${window.location.origin}/`;
    };

    const parseRatio = (ratio) => {
        const m = String(ratio || '').match(/^(\d+)\s*:\s*(\d+)$/);
        const w = m ? Number(m[1]) : 9;
        const h = m ? Number(m[2]) : 16;
        return { w: w || 9, h: h || 16 };
    };

    const getDemoUrl = () => {
        if (typeof window === 'undefined') return '';
        if (!selectedKioskId) return '';
        const base = getDisplayBaseUrl();
        const params = new URLSearchParams();
        params.set('room', String(selectedKioskId));
        params.set('orgID', String(props.cred.cOrganization_id));
        params.set('id', '100');
        if (demoRatio) params.set('demoRatio', demoRatio);
        return `${base}?${params.toString()}`;
    };
    const [modalBodyUpdate,setmodalBodyUpdate]=useState({
        name:"",
        device:null,
        date:"2020-11-11 00:00:00",
        dateFrom:"2020-11-11 00:00:00",
        dateTo:"2020-11-11 00:00:00",
        room:"A-D"
    })
    const [modalBody, setModalBody] = useState({
        file: "",
        text: "testik",
        v1: false,
        v2: true,
        v3: true
    });
    const fetchSlideGroups = async () => {
        try {
            const base = String(path || '').replace(/\/$/, '');
            const orgID = props.cred.cOrganization_id;
            const urls = Array.from(new Set([
                `${base}/getSlideGroup?orgID=${orgID}`,
                `${base}/api/getSlideGroup?orgID=${orgID}`,
            ]));
            let response;
            for (const url of urls) {
                try {
                    response = await axios.get(url);
                    break;
                } catch (e) {
                    if (e?.response?.status && e.response.status !== 404) throw e;
                }
            }
            if (!response) throw new Error('getSlideGroup not found (404)');
            // Filter out profile groups (groupId 1 and 2 are device types, not slideshow groups)
            const validGroups = (response.data || []).filter(group => {
                if (group.groupId === 1 || group.groupId === 2) return false;
                if (!group.groupName || !group.groupName.trim()) return false;
                const nameLower = String(group.groupName).toLowerCase();
                if (nameLower.includes('profile') || nameLower.includes('profil')) return false;
                return true;
            });
            setSlideGroups(validGroups);
        } catch (error) {
            console.error('Error fetching slide groups:', error);
            setSlideGroups([]);
        }
    };

    const loadMergedDevices = async () => {
        const orgId = props.cred.cOrganization_id;
        const [kiosksRes, displaysRes] = await Promise.all([
            axios.get(`${path}/getDeviceV2?orgID=${orgId}`).catch(() => ({ data: [] })),
            axios.get(`${path}/getDisplaysbyOrg/${orgId}`).catch(() => ({ data: [] }))
        ]);
        const kiosks = Array.isArray(kiosksRes.data) ? kiosksRes.data : [];
        const displays = Array.isArray(displaysRes.data) ? displaysRes.data : [];
        return [...displays, ...kiosks];
    };

    const fetchDevices = async () => {
        try {
            const merged = await loadMergedDevices();
            setDevices(merged);
        } catch (error) {
            console.error('Error fetching devices:', error);
            setDevices([]);
        }
    };

    const fetchDataCards = async (gr) => {
        setLoading(true);
        try {
            const orgID = props.cred.cOrganization_id;
            if (Number(gr) === DEFAULT_SCREEN_GROUP_ID) {
                const response = await axios.get(`${path}/getDefaultScreen`);
                const raw = Array.isArray(response.data) ? response.data : [];
                const defaultCards = raw.map((item) => ({
                    id: item.id,
                    Header: item.id === 1 ? 'Top' : item.id === 2 ? 'Bottom' : `Screen ${item.id}`,
                    CreatedBy: '',
                    isVisible: true,
                    Body: { file: item.path, imgURL: toPublicUploadUrl(item.path) },
                    deviceNames: []
                }));
                setCards(defaultCards);
            } else if (gr && Number(gr) > 0) {
                const response = await axios.get(`${path}/getCardsV3?orgID=${orgID}&group=${gr}`);
                setObje(response.data || [], gr);
            } else {
                const response = await axios.get(`${path}/getCardsV2?orgID=${orgID}`);
                setObje(response.data || [], gr);
            }
        } catch (error) {
            console.error('Error loading cards:', error);
            if (Number(gr) === DEFAULT_SCREEN_GROUP_ID) setCards([]);
            else setObje([], gr);
        } finally {
            setLoading(false);
        }
    }
    const setObje =  (x, currentGroupId = groupid) =>{
        const displaysOnly = (devices || []).filter(d => Number(d.device_group) === 1);
        let fld=[]
        for(let i = 0;i<x.length;i++){
            const id = x[i].id
            try {
                // Pokud je vybráno "all cards" (currentGroupId === 0), najít displeje, na kterých se karta zobrazuje
                let deviceNames = [];
                if (currentGroupId === 0) {
                    const cardGroupId = x[i].cRoomGroup_id != null ? x[i].cRoomGroup_id : (x[i].group_id != null ? x[i].group_id : null);
                    if (cardGroupId != null) {
                        const gid = Number(cardGroupId);
                        // Legacy/edge: některé DB mohou mít "no group" uložené jako 0 → chovej se jako NULL (All displays)
                        if (gid === 0) {
                            deviceNames = displaysOnly.length > 0 ? ['All displays'] : [];
                        } else {
                        const matchingDevices = displaysOnly.filter(d => {
                            const r = d.roomGroup ?? d.room_group;
                            const deviceGroupId = typeof r === 'number' ? r : Number(r);
                            return Number.isFinite(deviceGroupId) && deviceGroupId === gid;
                        });
                        deviceNames = matchingDevices.map(d => d.description || `Device ${d.id}`).filter(Boolean);
                        }
                    } else {
                        // Karta bez skupiny – zobrazuje se na všech displejích
                        deviceNames = displaysOnly.length > 0
                            ? ['All displays']
                            : [];
                    }
                }
                
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    isVisible: x[i].isVisible !== false && x[i].isVisible !== 0,
                    Body: {
                        file: x[i].path,
                        imgURL: toPublicUploadUrl(x[i].path)
                    },
                    // Přidat informace o displejích pouze když je vybráno "all cards"
                    deviceNames: currentGroupId === 0 ? deviceNames : []
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log(fld)
        setCards([...fld])
    }

    const setCardVisibility = async (cardId, visible) => {
        // Optimistic UI update
        setCards((prev) => prev.map((c) => (c.id === cardId ? { ...c, isVisible: Boolean(visible) } : c)));
        try {
            const orgId = props.cred?.cOrganization_id;
            const url = orgId ? `${path}/setCardVisibility/${cardId}?orgID=${encodeURIComponent(orgId)}` : `${path}/setCardVisibility/${cardId}`;
            const body = { isVisible: visible ? 1 : 0, orgID: orgId };
            try {
                await axios.put(url, body);
            } catch (putErr) {
                if (putErr?.response?.status === 404) await axios.post(url, body);
                else throw putErr;
            }
        } catch (e) {
            // rollback (refetch)
            await fetchDataCards();
            const status = e?.response?.status;
            const data = e?.response?.data;
            if (status === 409 && data?.missingColumn) {
                alert(
                    `Cannot change visibility because database column is missing: ${data.missingColumn}\n\n` +
                    `${data.hint || 'Run the migration SQL on the production database.'}`
                );
            } else {
                alert('Failed to change visibility.');
            }
        }
    };
    const delete_hanler = (id) => {
        if (Number(groupid) === DEFAULT_SCREEN_GROUP_ID) {
            if (window.confirm('Delete this default screen image?')) delete_fnc(id);
            return;
        }
        setCurrentID(id)
        setModalVariant(0)
        setModalLoaded(true)
    }
    const preview_handler = (id) => {
        const card = cards.find(c => c.id === id);
        if (card) {
            setPreviewCard(card);
            setPreviewOpen(true);
        }
    }
    const add_hanler = (id) => {
        setCurrentID(null)
        setModalVariant(1)
        setModalBody(null)
        setModalLoaded(true)
    }
    const modal_close_handler = (id) => {
        setCurrentID(null)
        setModalVariant(null)
        setModalLoaded(false)
        setModalBody(null)
        fetchDataCards(groupid)
    }
    const add_toCards_handler = (card) => {
        setCards([...cards, card])
        setIdCount(idCount + 1)
    }
    const delete_fnc = async (id) => {
        if (Number(groupid) === DEFAULT_SCREEN_GROUP_ID) {
            try {
                await axios.delete(`${path}/defaultscreendelete/${id}`);
                fetchDataCards(DEFAULT_SCREEN_GROUP_ID);
            } catch (error) {
                console.error('Error deleting default screen:', error);
                alert('Failed to delete.');
            }
            return;
        }
        try {
            const orgId = props.cred?.cOrganization_id;
            const url = orgId ? `${path}/deleteRow/${id}?orgID=${encodeURIComponent(orgId)}` : `${path}/deleteRow/${id}`;
            await axios.delete(url);
            setCards((prev) => prev.filter((c) => c.id !== id));
        } catch (error) {
            console.error('Error deleting row:', error);
            fetchDataCards(groupid);
        }
    }

    const openDefaultScreenEdit = (slotId) => {
        setDefaultScreenEditId(slotId === 1 || slotId === 2 ? slotId : 1);
        setDefaultScreenFile(null);
        setDefaultScreenModalOpen(true);
    }
    const handleDefaultScreenUpdate = async () => {
        if (!defaultScreenFile) { alert('Select an image first.'); return; }
        setDefaultScreenUploading(true);
        try {
            const formData = new FormData();
            formData.append('file', defaultScreenFile);
            formData.append('id', String(defaultScreenEditId));
            await axios.post(`${path}/defaultscreenupdate`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            setDefaultScreenModalOpen(false);
            fetchDataCards(DEFAULT_SCREEN_GROUP_ID);
        } catch (e) {
            console.error(e);
            alert('Failed to update.');
        } finally {
            setDefaultScreenUploading(false);
        }
    }
    const handleDefaultScreenDelete = async () => {
        if (!window.confirm('Delete this default screen image?')) return;
        try {
            await axios.delete(`${path}/defaultscreendelete/${defaultScreenEditId}`);
            setDefaultScreenModalOpen(false);
            fetchDataCards(DEFAULT_SCREEN_GROUP_ID);
        } catch (e) {
            console.error(e);
            alert('Failed to delete.');
        }
    }
    useEffect(()=>{
        fetchSlideGroups();
        fetchDevices();
        fetchDataCards(groupid);
    },[props.cred.cOrganization_id]);

    useEffect(() => {
        fetchDataCards(groupid);
    }, [groupid]);

    // Když se načtou devices a je vybráno "all cards", přepočítat názvy displejů pro karty
    useEffect(() => {
        if (groupid === 0 && devices.length > 0 && cards.length > 0) {
            // Znovu načíst karty s aktualizovanými názvy displejů
            fetchDataCards(0);
        }
    }, [devices.length]); // Pouze když se změní počet devices, ne samotné devices array

    useEffect(() => {
        const loadKiosks = async () => {
            try {
                const response = await axios.get(`${path}/getDeviceV2?orgID=${props.cred.cOrganization_id}`);
                const kiosks = response.data || [];
                setKioskDevices(kiosks);
                if (!selectedKioskId && kiosks.length > 0) {
                    setSelectedKioskId(String(kiosks[0].id));
                }
            } catch (e) {
                console.error('Error loading kiosk devices:', e);
                setKioskDevices([]);
            }
        };
        loadKiosks();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.cred.cOrganization_id]);

    const demoUrl = getDemoUrl();
    const demoFullscreenRef = useRef(null);
    const [isDemoFullscreen, setIsDemoFullscreen] = useState(false);

    useEffect(() => {
        if (!demoOpen) return;
        const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
        const vh = typeof window !== 'undefined' ? window.innerHeight : 0;
        const expectedWidth = demoRatio === '9:16'
            ? (vh * 0.95 * 9 / 16)
            : demoRatio === '16:9'
                ? Math.min(vw * 0.95, vh * 0.95 * 16 / 9)
                : Math.min(vw * 0.95, vh * 0.95 * 4 / 3);
        const expectedHeight = vh * 0.95;
        console.log('[Kiosk Demo – SpecOffer]', {
            demoRatio: demoRatio || '(nevybráno)',
            demoUrl: demoUrl || '(chybí)',
            viewport: `${vw}×${vh}`,
            očekávanéRozlišeníKontejneru: `${Math.round(expectedWidth)}×${Math.round(expectedHeight)}`,
            aspectRatio: demoRatio === '9:16' ? '9:16' : demoRatio === '16:9' ? '16:9' : demoRatio === '4:3' ? '4:3' : '?',
        });
    }, [demoOpen, demoRatio, demoUrl]);

    const syncDemoFullscreenState = useCallback(() => {
        if (typeof document === 'undefined') return;
        const current = demoFullscreenRef.current;
        setIsDemoFullscreen(Boolean(current && document.fullscreenElement === current));
    }, []);

    const toggleDemoFullscreen = useCallback(async () => {
        const el = demoFullscreenRef.current;
        if (!el || typeof document === 'undefined') return;
        try {
            if (document.fullscreenElement) {
                await document.exitFullscreen?.();
            } else {
                await el.requestFullscreen?.();
            }
        } catch (e) {
            console.error('Fullscreen toggle failed:', e);
        }
    }, []);

    const closeDemo = useCallback(async () => {
        try {
            if (typeof document !== 'undefined' && document.fullscreenElement) {
                await document.exitFullscreen?.();
            }
        } catch (e) {
            // ignore
        } finally {
            setDemoOpen(false);
        }
    }, []);

    useEffect(() => {
        if (typeof document === 'undefined') return;
        const onFs = () => syncDemoFullscreenState();
        document.addEventListener('fullscreenchange', onFs);
        syncDemoFullscreenState();
        return () => document.removeEventListener('fullscreenchange', onFs);
    }, [syncDemoFullscreenState]);

    // Group management functions
    const handleCreateGroup = async () => {
        if (!newGroupName.trim()) {
            alert('Please enter a group name');
            return;
        }
        
        try {
            const response = await postWithFallback('createSlideGroup', {
                groupName: newGroupName,
                orgID: props.cred.cOrganization_id,
                deviceIds: selectedDevices,
                showOnTotem: newGroupShowOnTotem
            });
            
            await fetchSlideGroups();
            await fetchDevices();
            
            setNewGroupName('');
            setSelectedDevices([]);
            setNewGroupShowOnTotem(false);
            setCreateGroupModalOpen(false);
            
            if (response.data && response.data.groupId) {
                setGroupid(response.data.groupId);
                fetchDataCards(response.data.groupId);
            }
            
            alert('Group created successfully');
        } catch (error) {
            console.error('Error creating group:', error);
            if (error?.response?.status === 404) {
                alert('Create group endpoint not available. Please contact administrator.');
            } else {
                alert(`Failed to create group: ${error?.message || 'Unknown error'}`);
            }
        }
    };

    const handleDeviceToggle = (deviceId) => {
        setSelectedDevices(prev => 
            prev.includes(deviceId) 
                ? prev.filter(id => id !== deviceId)
                : [...prev, deviceId]
        );
    };

    const openEditGroupModal = async () => {
        const g = slideGroups.find(sg => Number(sg.groupId) === Number(groupid));
        if (!g) {
            alert('Group not found.');
            return;
        }
        let list = devices;
        try {
            list = await loadMergedDevices();
            setDevices(list);
        } catch (_) {
            /* použij stávající devices */
        }
        setEditGroupName(g.groupName || '');
        const groupIdNum = Number(groupid);
        // Jen cDevice.roomGroup – po uložení je to jediný spolehlivý zdroj (slideshowGroupIds v DB často vůbec nejde uložit).
        const selected = (list || [])
            .filter((d) => Number(d.roomGroup ?? d.room_group) === groupIdNum)
            .map((d) => d.id);
        setEditGroupSelectedDevices(selected);
        // Načíst, jestli se má zobrazovat na totemu (z nastavení skupiny nebo z karet)
        setEditGroupShowOnTotem(g.showOnTotem === true || g.showOnTotem === 1);
        setEditGroupModalOpen(true);
    };

    const handleEditGroupDeviceToggle = (deviceId) => {
        setEditGroupSelectedDevices(prev => {
            const has = prev.some(id => String(id) === String(deviceId));
            if (has) return prev.filter(id => String(id) !== String(deviceId));
            return [...prev, deviceId];
        });
    };

    const handleSaveEditGroup = async () => {
        if (!groupid || !editGroupName.trim()) {
            alert('Please enter a group name.');
            return;
        }
        const intervalNum = Number(editGroupSlideInterval || '15');
        const safeInterval = Math.max(3, Math.min(300, Number.isFinite(intervalNum) ? intervalNum : 15));
        try {
            await putWithFallback(`updateSlideGroup/${groupid}`, {
                groupName: editGroupName.trim(),
                orgID: props.cred.cOrganization_id,
                deviceIds: editGroupSelectedDevices,
                showOnTotem: editGroupShowOnTotem
            });
            const orgId = props.cred?.cOrganization_id;
            const base = String(path || '').replace(/\/$/, '');
            const groupNum = Number(groupid);
            // Propagate slide interval to all devices in this group (displays + kiosks)
            if (Array.isArray(editGroupSelectedDevices) && editGroupSelectedDevices.length > 0) {
                await Promise.all(editGroupSelectedDevices.map(async (deviceId) => {
                    try {
                        const urlGet = orgId
                            ? `${path}/getDeviceSettings/${deviceId}?orgID=${encodeURIComponent(orgId)}`
                            : `${path}/getDeviceSettings/${deviceId}`;
                        const resp = await axios.get(urlGet);
                        const current = resp.data?.settings || {};
                        const merged = {
                            ...current,
                            slideIntervalSec: safeInterval
                        };
                        const urlSet = `${path}/setDeviceSettings/${deviceId}`;
                        await axios.put(urlSet, { settings: merged, orgID: orgId });
                    } catch (e) {
                        console.error('[SpecOffer] Failed to update slideIntervalSec for device', deviceId, e);
                    }
                }));
            }
            // Slideshow skupina může být i v device settings (slideshowGroupIds) – bez úpravy zůstane v mapě a modal znovu zaškrtne kiosk.
            let mergedAfter = [];
            try {
                mergedAfter = await loadMergedDevices();
            } catch (e) {
                console.warn('[SpecOffer] loadMergedDevices after save failed', e);
            }
            if (mergedAfter.length > 0) {
                await Promise.all(mergedAfter.map(async (device) => {
                    const deviceId = device.id;
                    const shouldHave = editGroupSelectedDevices.some((id) => String(id) === String(deviceId));
                    try {
                        const urlGet = orgId
                            ? `${base}/getDeviceSettings/${deviceId}?orgID=${encodeURIComponent(orgId)}`
                            : `${base}/getDeviceSettings/${deviceId}`;
                        const resp = await axios.get(urlGet);
                        const current = resp.data?.settings || {};
                        const currentIds = Array.isArray(current.slideshowGroupIds)
                            ? current.slideshowGroupIds
                                .map((x) => Number(x))
                                .filter((n) => Number.isFinite(n) && n > 0)
                                .map((n) => Math.floor(n))
                            : [];
                        const nextIds = shouldHave
                            ? Array.from(new Set([...currentIds, groupNum]))
                            : currentIds.filter((id) => id !== groupNum);
                        const sortedEq =
                            JSON.stringify([...currentIds].sort((a, b) => a - b)) ===
                            JSON.stringify([...nextIds].sort((a, b) => a - b));
                        if (sortedEq) return;
                        await axios.put(`${base}/setDeviceSettings/${deviceId}`, {
                            settings: { ...current, slideshowGroupIds: nextIds },
                            orgID: orgId
                        });
                    } catch (e) {
                        console.error('[SpecOffer] Failed to sync slideshowGroupIds for device', deviceId, e);
                    }
                }));
            }
            await fetchSlideGroups();
            await fetchDevices();
            setEditGroupModalOpen(false);
            setEditGroupName('');
            setEditGroupSelectedDevices([]);
            setEditGroupSlideInterval('15');
            setEditGroupShowOnTotem(false);
            alert('Group updated.');
        } catch (error) {
            console.error('Error updating group:', error);
            if (error?.response?.status === 404) {
                alert('Update group endpoint is not available.');
            } else {
                alert(`Error: ${error?.message || 'Failed to save.'}`);
            }
        }
    };

    const handleDeleteGroup = async () => {
        if (!groupid) return;
        if (!window.confirm('Delete this group? Devices will be unassigned from it.')) return;
        try {
            const orgId = encodeURIComponent(props.cred.cOrganization_id || '');
            await deleteWithFallback(`deleteSlideGroup/${groupid}?orgID=${orgId}`, {
                data: { orgID: props.cred.cOrganization_id }
            });
            await fetchSlideGroups();
            await fetchDevices();
            setEditGroupModalOpen(false);
            setEditGroupName('');
            setEditGroupSelectedDevices([]);
            setGroupid(0);
            fetchDataCards(0);
            alert('Group deleted.');
        } catch (error) {
            console.error('Error deleting group:', error);
            if (error?.response?.status === 404) {
                alert('Delete group endpoint is not available.');
            } else {
                alert(`Error: ${error?.message || 'Failed to delete.'}`);
            }
        }
    };

    const getDeviceOtherGroup = (device) => {
        const rg = Number(device.roomGroup ?? device.room_group);
        if (!Number.isFinite(rg) || rg === 0) return { inOtherGroup: false };
        const currentGid = Number(groupid);
        if (rg === currentGid) return { inOtherGroup: false };
        const other = (slideGroups || []).find(sg => Number(sg.groupId) === rg);
        return { inOtherGroup: true, otherGroupName: other?.groupName || `Group ${rg}` };
    };

    const isDeviceSelectedInEdit = (deviceId) =>
        editGroupSelectedDevices.some(id => String(id) === String(deviceId));

    // Pro "All cards (no group)" chceme umožnit přidat fotku bez skupiny (NULL) – to je groupid=0.
    const effectiveGroupIdForModal = groupid != null ? Number(groupid) : 0;

    return <div className={classes.cont}>
        {/* Group selection + create new group */}
        <Box sx={{
            width: '100%',
            maxWidth: 1100,
            margin: '0 auto',
            mb: 2,
            p: { xs: 2, sm: 2.5 },
            borderRadius: 2,
            border: '1px solid #e6e6e6',
            background: '#fff',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 1.5, sm: 2 }, 
            alignItems: { xs: 'stretch', sm: 'center' }
        }}>
            <FormControl sx={{
                width: { xs: '100%', sm: '50%' },
                minWidth: { xs: '100%', sm: 280 }
            }}>
                <InputLabel id="group-select-label" sx={{ fontSize: '15px' }}>Group</InputLabel>
                        <Select
                    labelId="group-select-label"
                    id="group-select"
                    value={groupid}
                    label="Group"
                    onChange={(e)=>{
                        setGroupid(e.target.value)
                        fetchDataCards(e.target.value)
                    }}
                    sx={{
                        height: { xs: '48px', sm: '56px' },
                        fontSize: '15px',
                        backgroundColor: 'white',
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderWidth: 2
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderWidth: 2
                        }
                    }}
                >
                    <MenuItem value={0}>All cards (no group)</MenuItem>
                    {props.cred?.cOrganization_id === HOLIDAY_INN_ORG_ID && (
                        <MenuItem value={DEFAULT_SCREEN_GROUP_ID}>Default screen (Totem)</MenuItem>
                    )}
                    {slideGroups.length > 0 && slideGroups.map((x)=>{
                        return  <MenuItem key={x.groupId} value={x.groupId}>{x.groupName || `Group ${x.groupId}`}</MenuItem>
                    })}
                        </Select>
                    </FormControl>
            <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 1.5, sm: 1.5 },
                width: { xs: '100%', sm: 'auto' }
            }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setCreateGroupModalOpen(true)}
                    sx={{
                        width: { xs: '100%', sm: 'auto' },
                        whiteSpace: 'nowrap',
                        minWidth: { xs: '100%', sm: 180 },
                        height: { xs: '48px', sm: '56px' },
                        fontSize: '15px',
                        fontWeight: 600,
                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                        '&:hover': {
                            boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
                            transform: 'translateY(-1px)'
                        },
                        transition: 'all 0.2s'
                    }}
                >
                    Create group
                </Button>

                {Number(groupid) !== DEFAULT_SCREEN_GROUP_ID && (
                    <Button
                        variant="outlined"
                        disabled={!groupid}
                        onClick={openEditGroupModal}
                        startIcon={<EditIcon />}
                        sx={{
                            width: { xs: '100%', sm: 'auto' },
                            whiteSpace: 'nowrap',
                            minWidth: { xs: '100%', sm: 140 },
                            height: { xs: '48px', sm: '56px' },
                            fontSize: '15px',
                            fontWeight: 600,
                            borderWidth: 2,
                            '&:hover': { borderWidth: 2 }
                        }}
                    >
                        Edit group
                    </Button>
                )}
                </Box>
        </Box>

        {loading && (
            <div className={classes.loader}>
                <CircularProgress size={40} />
            </div>
        )}
        {!loading && cards.map(x => (
            <MediaS
                typ={1}
                key={x.id}
                delete={delete_hanler}
                body={x.Body}
                text={x.Header}
                id={x.id}
                preview={preview_handler}
                isVisible={x.isVisible}
                onVisibilityChange={(v) => setCardVisibility(x.id, v)}
                deviceNames={x.deviceNames || []}
                onUpdateDefaultScreen={Number(groupid) === DEFAULT_SCREEN_GROUP_ID ? openDefaultScreenEdit : undefined}
            />
        ))}
        {!loading && Number(groupid) !== DEFAULT_SCREEN_GROUP_ID && <AddMedia click={add_hanler}/>}
        {modalLoaded &&
            <ModalView V={modalVariant} ModalBody={modalBody} close={modal_close_handler} add={add_toCards_handler}
                       addID={idCount} currentID={currentID} delFNC={delete_fnc} cred={user} modalBodyUpdate={modalBodyUpdate}
                       groupID={effectiveGroupIdForModal} device={devices} updateCount={() => fetchDataCards(groupid)}/>}

        {/* Default screen (Totem) – změna obrázku Top/Bottom */}
        <Dialog open={defaultScreenModalOpen} onClose={() => setDefaultScreenModalOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Default screen (Totem)</DialogTitle>
            <DialogContent sx={{ pt: 1 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Obrázky se zobrazí na totemu, když neběží žádný meeting. Stejné nastavení jako v Meeting rooms → Set default.
                </Typography>
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Screen location</InputLabel>
                    <Select
                        value={defaultScreenEditId}
                        label="Screen location"
                        onChange={(e) => setDefaultScreenEditId(Number(e.target.value))}
                    >
                        <MenuItem value={1}>Top</MenuItem>
                        <MenuItem value={2}>Bottom</MenuItem>
                    </Select>
                </FormControl>
                <Button variant="outlined" component="label" fullWidth sx={{ mb: 1 }}>
                    {defaultScreenFile ? defaultScreenFile.name : 'Choose image'}
                    <input type="file" accept="image/*" hidden onChange={(e) => setDefaultScreenFile(e.target.files?.[0] || null)} />
                </Button>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setDefaultScreenModalOpen(false)}>Cancel</Button>
                <Button color="error" onClick={handleDefaultScreenDelete}>Delete</Button>
                <Button variant="contained" disabled={!defaultScreenFile || defaultScreenUploading} onClick={handleDefaultScreenUpdate}>
                    {defaultScreenUploading ? <CircularProgress size={24} /> : 'Update'}
                </Button>
            </DialogActions>
        </Dialog>

        {/* Kiosk Demo Modal - Paper i obsah v poměru 16:9 / 9:16 / 4:3 (iframe pak má správné rozměry) */}
        <Dialog
            open={demoOpen}
            onClose={closeDemo}
            maxWidth={false}
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    overflow: 'hidden',
                    margin: 'auto',
                    ...(demoRatio === '9:16'
                        ? { aspectRatio: '9/16', width: 'calc(95vh * 9 / 16)', height: 'auto', maxHeight: '95vh' }
                        : demoRatio === '16:9'
                            ? { aspectRatio: '16/9', width: 'min(95vw, calc(95vh * 16 / 9))', height: 'auto', maxHeight: '95vh' }
                            : { aspectRatio: '4/3', width: 'min(95vw, calc(95vh * 4 / 3))', height: 'auto', maxHeight: '95vh' }
                    )
                }
            }}
        >
            <DialogContent
                ref={demoFullscreenRef}
                sx={{
                    p: 0,
                    position: 'relative',
                    backgroundColor: '#111',
                    height: '100%',
                    overflow: 'hidden'
                }}
            >
                <IconButton
                    aria-label={isDemoFullscreen ? "exit fullscreen" : "fullscreen"}
                    onClick={toggleDemoFullscreen}
                    sx={{
                        position: 'absolute',
                        left: 8,
                        top: 8,
                        color: 'white',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1,
                        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
                    }}
                >
                    {isDemoFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                </IconButton>
                <IconButton
                    aria-label="close"
                    onClick={closeDemo}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'white',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1,
                        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Box
                    component="div"
                    sx={{
                        width: '100%',
                        height: '100%',
                        aspectRatio: demoRatio === '9:16' ? '9/16' : demoRatio === '16:9' ? '16/9' : '4/3',
                        boxSizing: 'border-box',
                        maxWidth: '100%',
                        maxHeight: '100%'
                    }}
                >
                    {demoUrl ? (
                        <iframe
                            title="Kiosk demo"
                            src={demoUrl}
                            key={demoUrl}
                            allow="fullscreen"
                            allowFullScreen
                            style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
                        />
                    ) : (
                        <Box sx={{ color: '#fff', p: 2 }}>Could not build demo URL.</Box>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
        
        {/* Preview Modal */}
        <Dialog
            open={previewOpen}
            onClose={() => setPreviewOpen(false)}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    maxHeight: '95vh',
                    backgroundColor: '#000'
                }
            }}
        >
            <DialogContent sx={{ 
                p: 0, 
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '70vh',
                backgroundColor: '#000'
            }}>
                <IconButton
                    aria-label="close"
                    onClick={() => setPreviewOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'white',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1,
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.7)'
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
                {previewCard && (
                    <>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 3,
                            boxSizing: 'border-box'
                        }}>
                            <img
                                src={previewCard.Body.imgURL}
                                alt={previewCard.Header || 'Preview'}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '85vh',
                                    width: 'auto',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    borderRadius: '8px'
                                }}
                                onError={(e) => {
                                    console.error('Error loading preview image:', previewCard.Body.imgURL);
                                    e.target.style.display = 'none';
                                }}
                            />
                        </Box>
                        {previewCard.Header && (
                            <Box sx={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                color: 'white',
                                p: 2,
                                textAlign: 'center'
                            }}>
                                <Typography variant="h6" sx={{ color: 'white', fontWeight: 500 }}>
                                    {previewCard.Header}
                                </Typography>
                            </Box>
                        )}
                    </>
                )}
            </DialogContent>
        </Dialog>

        {/* Create new group modal */}
        <Dialog 
            open={createGroupModalOpen} 
            onClose={() => setCreateGroupModalOpen(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
                }
            }}
        >
            <DialogTitle sx={{ 
                fontSize: '20px', 
                fontWeight: 600,
                pb: 1,
                borderBottom: '1px solid #e0e0e0'
            }}>
                Create new group
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Group name"
                    fullWidth
                    variant="outlined"
                    value={newGroupName}
                    onChange={(e) => setNewGroupName(e.target.value)}
                    sx={{ 
                        mb: 3, 
                        mt: 1,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px'
                        }
                    }}
                />
                <Box>
                    <InputLabel sx={{ 
                        mb: 1.5, 
                        fontSize: '15px',
                        fontWeight: 500,
                        color: '#333'
                    }}>
                        Select devices (kiosks and tablets)
                    </InputLabel>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                        On tablets, when there is a meeting, it will override the slideshow.
                    </Typography>
                    <Box sx={{ 
                        maxHeight: 300, 
                        overflow: 'auto', 
                        border: '2px solid #e0e0e0', 
                        borderRadius: '8px', 
                        p: 2,
                        backgroundColor: '#f8f9fa',
                        '&::-webkit-scrollbar': {
                            width: '8px'
                        },
                        '&::-webkit-scrollbar-track': {
                            background: '#f1f1f1',
                            borderRadius: '4px'
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#b0bec5',
                            borderRadius: '4px',
                            '&:hover': {
                                background: '#90a4ae'
                            }
                        }
                    }}>
                        {/* Totem checkbox - zobrazit obrázky z této skupiny i na totemu */}
                        {props.cred?.cOrganization_id === HOLIDAY_INN_ORG_ID && (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={newGroupShowOnTotem}
                                        onChange={(e) => setNewGroupShowOnTotem(e.target.checked)}
                                        sx={{
                                            '&.Mui-checked': { color: '#1976d2' }
                                        }}
                                    />
                                }
                                label="Totem (id=3) - Show images on totem display"
                                sx={{
                                    display: 'block',
                                    mb: 2,
                                    pb: 2,
                                    borderBottom: '1px solid #e0e0e0',
                                    '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)', borderRadius: '4px', padding: '4px 8px', margin: '4px -8px' }
                                }}
                            />
                        )}
                        {devices.length === 0 ? (
                            <Box sx={{ 
                                p: 3, 
                                textAlign: 'center', 
                                color: 'text.secondary',
                                fontSize: '14px'
                            }}>
                                No devices available
                            </Box>
                        ) : (
                            devices.map((device) => (
                                <FormControlLabel
                                    key={device.id}
                                    control={
                                        <Checkbox
                                            checked={selectedDevices.includes(device.id)}
                                            onChange={() => handleDeviceToggle(device.id)}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: '#1976d2'
                                                }
                                            }}
                                        />
                                    }
                                    label={`${device.description || `Device ${device.id}`} (${device.device_group === 1 ? 'Display' : device.device_group === 2 ? 'Kiosk' : 'Unknown'})`}
                                    sx={{
                                        display: 'block',
                                        mb: 1,
                                        '&:hover': {
                                            backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                            borderRadius: '4px',
                                            padding: '4px 8px',
                                            margin: '4px -8px'
                                        }
                                    }}
                                />
                            ))
                        )}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ 
                px: 3, 
                pb: 2.5,
                pt: 2,
                borderTop: '1px solid #e0e0e0',
                gap: 1
            }}>
                <Button 
                    onClick={() => {
                        setCreateGroupModalOpen(false);
                        setNewGroupName('');
                        setSelectedDevices([]);
                        setNewGroupShowOnTotem(false);
                    }}
                    sx={{
                        minWidth: 100,
                        fontWeight: 500
                    }}
                >
                    Cancel
                </Button>
                <Button 
                    onClick={handleCreateGroup} 
                    variant="contained"
                    disabled={!newGroupName.trim()}
                    sx={{
                        minWidth: 120,
                        fontWeight: 600,
                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                        '&:hover': {
                            boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)'
                        },
                        '&:disabled': {
                            backgroundColor: '#e0e0e0',
                            color: '#9e9e9e'
                        }
                    }}
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>

        {/* Edit group modal */}
        <Dialog
            open={editGroupModalOpen}
            onClose={() => { setEditGroupModalOpen(false); setEditGroupName(''); setEditGroupSelectedDevices([]); setEditGroupSlideInterval('15'); setEditGroupShowOnTotem(false); }}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
                }
            }}
        >
            <DialogTitle sx={{ fontSize: '20px', fontWeight: 600, pb: 1, borderBottom: '1px solid #e0e0e0' }}>
                Edit group
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Group name"
                    fullWidth
                    variant="outlined"
                    value={editGroupName}
                    onChange={(e) => setEditGroupName(e.target.value)}
                    sx={{ mb: 2, mt: 1, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                />
                <TextField
                    margin="dense"
                    label="Slide interval (s)"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={editGroupSlideInterval}
                    onChange={(e) => setEditGroupSlideInterval(e.target.value)}
                    helperText="How long each image is shown on all kiosks/displays in this group (3–300 seconds)."
                    inputProps={{ min: 3, max: 300, step: 1 }}
                    sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                />
                <Box>
                    <InputLabel sx={{ mb: 1.5, fontSize: '15px', fontWeight: 500, color: '#333' }}>
                        Devices that show this group (selected devices)
                    </InputLabel>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                        Kiosks and tablets can be assigned. On tablets, when there is a meeting, it will override the slideshow.
                    </Typography>
                    <Box sx={{
                        maxHeight: 300,
                        overflow: 'auto',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px',
                        p: 2,
                        backgroundColor: '#f8f9fa',
                        '&::-webkit-scrollbar': { width: '8px' },
                        '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '4px' },
                        '&::-webkit-scrollbar-thumb': { background: '#b0bec5', borderRadius: '4px', '&:hover': { background: '#90a4ae' } }
                    }}>
                        {/* Totem checkbox - zobrazit obrázky z této skupiny i na totemu */}
                        {props.cred?.cOrganization_id === HOLIDAY_INN_ORG_ID && (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={editGroupShowOnTotem}
                                        onChange={(e) => setEditGroupShowOnTotem(e.target.checked)}
                                        sx={{
                                            '&.Mui-checked': { color: '#1976d2' }
                                        }}
                                    />
                                }
                                label="Totem (id=3) - Show images on totem display"
                                sx={{
                                    display: 'block',
                                    mb: 2,
                                    pb: 2,
                                    borderBottom: '1px solid #e0e0e0',
                                    '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)', borderRadius: '4px', padding: '4px 8px', margin: '4px -8px' }
                                }}
                            />
                        )}
                        {(devices || []).length === 0 ? (
                            <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary', fontSize: '14px' }}>
                                No devices available
                            </Box>
                        ) : (
                            (devices || []).map((device) => {
                                const { inOtherGroup, otherGroupName } = getDeviceOtherGroup(device);
                                const typeLabel = device.device_group === 1 ? 'Display' : device.device_group === 2 ? 'Kiosk' : '?';
                                const label = `${device.description || `Device ${device.id}`} (${typeLabel})${inOtherGroup ? ` — in group "${otherGroupName}"` : ''}`;
                                return (
                                    <FormControlLabel
                                        key={String(device.id)}
                                        control={
                                            <Checkbox
                                                checked={isDeviceSelectedInEdit(device.id)}
                                                onChange={() => !inOtherGroup && handleEditGroupDeviceToggle(device.id)}
                                                disabled={inOtherGroup}
                                                sx={{
                                                    '&.Mui-checked': { color: '#1976d2' },
                                                    '&.Mui-disabled': { color: '#9e9e9e' }
                                                }}
                                            />
                                        }
                                        label={label}
                                        sx={{
                                            display: 'block',
                                            mb: 1,
                                            opacity: inOtherGroup ? 0.65 : 1,
                                            color: inOtherGroup ? '#757575' : 'inherit',
                                            '&:hover': inOtherGroup ? {} : { backgroundColor: 'rgba(25, 118, 210, 0.04)', borderRadius: '4px', padding: '4px 8px', margin: '4px -8px' }
                                        }}
                                    />
                                );
                            })
                        )}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5, pt: 2, borderTop: '1px solid #e0e0e0', gap: 1, flexWrap: 'wrap' }}>
                <Button
                    onClick={handleDeleteGroup}
                    color="error"
                    variant="outlined"
                    sx={{ mr: 'auto', fontWeight: 500 }}
                >
                    Delete group
                </Button>
                <Button
                    onClick={() => { setEditGroupModalOpen(false); setEditGroupName(''); setEditGroupSelectedDevices([]); }}
                    sx={{ minWidth: 100, fontWeight: 500 }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSaveEditGroup}
                    variant="contained"
                    disabled={!editGroupName.trim()}
                    sx={{
                        minWidth: 120,
                        fontWeight: 600,
                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                        '&:hover': {
                            boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)'
                        },
                        '&:disabled': {
                            backgroundColor: '#e0e0e0',
                            color: '#9e9e9e'
                        }
                    }}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    </div>
}
export default SpecOffer